module.exports = __webpack_public_path__ + "static/media/closing_report_logo.7064f3fd.png";